import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#05603c] flex flex-col items-center justify-center px-4 text-center">
      <Helmet>
        <title>Página no encontrada | El Chel</title>
      </Helmet>

      <div className="text-[clamp(5rem,20vw,10rem)] font-extrabold text-brand-light leading-none select-none">
        404
      </div>

      <h1 className="text-[clamp(1.4rem,4vw,2.2rem)] font-extrabold text-white mb-3">
        ¡Ups! Esta página no existe
      </h1>
      <p className="text-[clamp(0.95rem,2vw,1.1rem)] text-[#ff6d00] max-w-[480px] mb-8 leading-relaxed">
        Parece que te perdiste, pero no te preocupes — en El Chel siempre hay un lugar para ti.
      </p>

      <Link
        to="/"
        className="px-8 py-3 rounded-full bg-gradient-brand text-white font-bold text-lg shadow-brand-strong hover:opacity-90 transition-opacity duration-200"
      >
        Volver al inicio
      </Link>
    </div>
  );
};

export default NotFound;
